__webpack_require__.p = "/wp-content/themes/multidot-theme/vue-app-2/dist/";